<template>
    <div class="px-4">
        <OrderHistoryItem
            v-for="(myOrder,index) in myOrders"
            :key="index"
            :myOrder="myOrder"
            @clickReOrder="clickReOrder($event)"
            @clickFav="clickFav(index)"
            @clickDetail="clickDetail($event)"
        >
        </OrderHistoryItem>
    </div>
</template>
<script>
// component
import OrderHistoryItem from '@/module/MyOrder/component/OrderHistory/OrderHistoryItem.vue';
// mixins
import LocaleMixin from '@/mixin/LocaleMixin';
import ModalMixin from '@/mixin/ModalMixin';
import ErrorApiMixin from '@/mixin/ErrorApiMixin.js';
// helper
import DatetimeHelper from '@/helper/DatetimeHelper';
// service
import BKMyFavorite from '@/module/MyFavorite/service/BKMyFavorite';
import BKMyOrder from '@/module/MyOrder/service/BKMyOrder';

export default {
    name: "OrderList",
    mixins: [LocaleMixin, ModalMixin, ErrorApiMixin],
    components: {
        OrderHistoryItem,
    },
    data: function() {
        return {
            myOrders: null,
            myOrderDetail: [],
            isLoaded: false,
        }
    },
    created: function() {
        this.getOrder();
    },
    methods: {
        getStatusColor: function(status){
            if(!status) return;
            return status.toLowerCase() == 'Completed' ? 'text-a-green-198737' : 'text-a-brown-502314' //'text-a-red-d14545';
        },
        getCreateDate: function(createDate) {
            return DatetimeHelper.dateShortFormat(createDate);
        },
        getOrder: function(){
            this.modal.loadingModal.show();
            return new Promise((resolve) => {
                BKMyFavorite.apiGetOrderFavorite().subscribe({
                    next: (orders) => {
                        setTimeout(()=>{
                            this.modal.loadingModal.hide();
                        },100)
                        this.myOrders = orders;
                        this.isLoaded = true;
                        resolve(true);
                    },
                    error: (err) => {
                        this.isLoaded = true;
                        this.errorApi(err);
                        resolve(null);
                    },
                });
            });
        },

        clickFav: function(index){
            this.modal.loadingModal.show();
            this.tracking.event('favorite','click favorite list', `favorite| ${this.myOrders[index].tranId}`);

            return new Promise((resolve) => {
                BKMyOrder.apiPostFavourite(this.myOrders[index].rowKey).subscribe({
                    next: () => {
                        setTimeout(()=>{
                            this.modal.loadingModal.hide();
                        }, 100)
                        this.getOrder();
                        resolve(true);
                    },
                    error: (err) => {
                        this.modal.loadingModal.hide();
                        this.errorApi(err);
                        resolve(null);
                    },
                });
            });
        },

        clickDetail: async function(myOrder) {
            this.modal.loadingModal.show();
            if (await this.apiGetDetail(myOrder.tranId)) {
                console.log(this.myOrderDetail);
                this.modal.orderDetailModal.clearModal()
                                        .setBtnOk("Reorder")
                                        .setorderItem(myOrder)
                                        .setOrderDetail(this.myOrderDetail)
                                        .show();
                this.modal.orderDetailModal.onClickOk(() => {
                    this.reOrder(myOrder.tranId);
                });
            }
        },
        apiGetDetail: async function(tranId) {
            return new Promise((resolve) => {
                this.myOrderDetail = [];
                BKMyOrder.apiGetOrderHistoryDetail(tranId).subscribe({
                    next: (myOrders) => {
                        for (var myOrder of myOrders) {
                            this.myOrderDetail.push(myOrder);
                        }
                        this.modal.loadingModal.hide();
                        resolve(true);
                    },
                    error: (err) => {
                        this.modal.loadingModal.hide();
                        resolve(false);
                        this.errorApi(err);
                    },
                });
            });
        },
        clickReOrder: function(myOrder) {
            this.reOrder(myOrder.tranId);
        },
        reOrder: async function(tranId) {
            this.modal.loadingModal.show();
            if (await this.apiPostReOrder(tranId)) {
                this.$router.push("/ordersummary");
            }
        },
        apiPostReOrder: async function(tranId) {
            return new Promise((resolve) => {
                BKMyOrder.apiPostReOrder(tranId).subscribe({
                    next: (data) => {
                        console.log(data);
                        this.modal.loadingModal.hide();
                        resolve(true);
                    },
                    error: (err) => {
                        this.modal.loadingModal.hide();
                        resolve(false);
                        this.errorApi(err);
                    },
                });
            });
        },
    },

}
</script>
<style lang="scss" scoped>
</style>
